import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'app/services/auth.service';
import { TransactionService } from 'app/services/models/transaction.service';

@Component({
  selector: 'app-vault-transaction-movements-dialog',
  templateUrl: './vault-transaction-movements-dialog.component.html',
  styleUrls: ['./vault-transaction-movements-dialog.component.scss']
})
export class VaultTransactionMovementsDialogComponent implements OnInit {
  @Input() movements: any[] = [];
  @Input() currency!: string;  // 💡 para birimi alınıyor

  constructor(public activeModal: NgbActiveModal,
    public authService:AuthService,
    public transactionService:TransactionService
  ) {}

  ngOnInit(): void {
  }

  callBackFun(){
    this.activeModal.close();
    this.transactionService.sendEvent(true);
  }
}
